export default {
  methods: {
    /**
     * Add prefix to given location defined in 'locationPrefix' constant.
     * @param location
     * @return {*}
     */
    nearLocation(location) {
      const locationPrefix = this.bp('storeFinderNear');
      return location && !location.startsWith(locationPrefix) ? `${locationPrefix} ${location}` : location;
    },
  },
};
